import * as React from 'react';
import { View, StyleSheet } from 'react-native';
import { CurrencyAmountText, Spacer } from 'design-system';
import { useAppSelector } from 'store/hooks';
import Text from 'design-system/Text';
import { zeroCurrencyAmount } from '../constants';
const TotalInvestmentsContainer = ({ onLayout }) => {
    const portfolioValue = useAppSelector((state) => state.invest.portfolioValue);
    return (<>
      <Spacer h={32}/>
      <View style={styles.balanceContainer} onLayout={onLayout}>
        <Text Text-14 centered Secondary>
          Total investments
        </Text>
        <CurrencyAmountText size="L" value={portfolioValue ? { amount: portfolioValue.value, currency: portfolioValue.currency } : zeroCurrencyAmount}/>
      </View>
      <Spacer h={24}/>
    </>);
};
export default React.memo(TotalInvestmentsContainer);
const styles = StyleSheet.create({
    balanceContainer: {
        alignItems: 'center',
    },
});
